export default __webpack_public_path__ + "static/media/Garbage.6cdde03a.svg";